var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rich-text-editor-container"},[_c('div',{ref:"editor",staticClass:"quill-editor"}),_c('div',{staticClass:"char-counter"},[_vm._v(" Caracteres: "+_vm._s(_vm.charCount)+" "),(_vm.charCount > 10000)?_c('span',{staticClass:"info"},[_vm._v(" (Se dividirá automáticamente en la base de datos) ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }